export default __webpack_public_path__ + "static/media/DeFi.52263289.png";